import { render } from "./pb-pagecontactteam.vue?vue&type=template&id=50c59792"
import script from "./pb-pagecontactteam.vue?vue&type=script&lang=js"
export * from "./pb-pagecontactteam.vue?vue&type=script&lang=js"

import "./pb-pagecontactteam.vue?vue&type=style&index=0&id=50c59792&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__